import React, { useEffect, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import {
  navAuthLinks,
  navMobileAuthLinks,
  navMobileUnauthLinks,
  navUnauthLinks,
} from "../../constants/app-constants";
import Modal from "../../components/Modal";
import Login from "../../containers/Login/Login";

//Importing images
import DesktopLogo from "../../assets/logos/desktop-logo.png";
import MobileLogo from "../../assets/logos/mobile-logo.png";
import DesktopLogoDark from "../../assets/logos/desktop-logo-dark.png";
import MobileLogoDark from "../../assets/logos/mobile-logo-dark.png";
import QuestionMark from "../../assets/icons/questionmark-icon.png";
import QuestionMarkL from "../../assets/icons/questionmark-icon-l.png";
import OpenMenu from "../../assets/icons/open-icon.png";
import OpenMenuL from "../../assets/icons/open-icon-l.png";
import "./Header.scss";
import { Auth } from "aws-amplify";
import useAuthentication from "../../hooks/useLoginAuthentication";
import { AiOutlineClose } from "react-icons/ai";
import AccountDeleteModal from "../../components/accountDeleteModal";
import { delete_cookie } from "../../utils/common.utils";
import GeneralModal from "../../containers/HomePage/Modal";
//import useLoginAuthentication from "../../hooks/useLoginAuthentication.js";
import { connect } from "react-redux";
import { UPDATE_AUTH_DATA } from "../../middleware/constants/auth.constants";
import { useSelector } from "react-redux";

const Header = ({ loginStatus, loginUserData, updateLoginStatus }) => {
  const width = window.innerWidth;
  let history = useHistory();
  const location = useLocation();
  const [theme, setTheme] = useState(
    location.pathname === "/" ? "light" : "dark"
  );
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [accountDeleteModal, setAccountDeleteModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loginModalOpen, setLoginModalOpen] = useState(false);
  const userInfo = useSelector((state) => state.auth.userData);

  const logAuth = useAuthentication();

  // useEffect(() => {
  //   logAuth.getLoginAuthentication();

  // },[loginStatus,loginUserData]);
  // useEffect(() => {
  //   setIsAuthenticated(logAuth.authenticated.loginStatus);
  //   updateLoginStatus(logAuth.authenticated.loginStatus,logAuth.authenticated.userData)
  // },[logAuth.authenticated]);
  useEffect(() => {
    setTheme(location.pathname === "/" ? "light" : "dark");
  }, [location.pathname]);

  useEffect(() => {
    logAuth
      .getIsUaAuthentication(userInfo)
      .then(({ status, userData, createAccount }) => {
        updateLoginStatus(status, userData, createAccount);
        setIsAuthenticated(status);
      });
  }, []);

  const navLinks =
    theme === "light"
      ? navUnauthLinks
      : isAuthenticated
      ? navAuthLinks
      : navUnauthLinks;
  const navMobileLinks =
    theme === "light"
      ? navMobileUnauthLinks
      : isAuthenticated
      ? navMobileAuthLinks
      : navMobileUnauthLinks;

  const handleOpenMenu = () => {
    document.getElementById("mobile-menulist").style.display = "block";
    document.getElementsByClassName("header-menu")[1].style.display = "none";
    document.getElementsByClassName("header-menu")[2].style.display = "block";
    document.getElementsByTagName("html")[0].style.overflowY = "hidden";
    document.getElementsByTagName("body")[0].style.overflowY = "hidden";
  };

  const handleCloseMenu = () => {
    document.getElementById("mobile-menulist").style.display = "none";
    document.getElementsByClassName("header-menu")[1].style.display = "block";
    document.getElementsByClassName("header-menu")[2].style.display = "none";
    document.getElementsByTagName("html")[0].style.overflowY = "scroll";
    document.getElementsByTagName("body")[0].style.overflowY = "scroll";
  };
  history.listen((location, action) => {
    logAuth
      .getIsUaAuthentication()
      .then(({ status }) => setIsAuthenticated(status));
  });
  const openModal = () => {
    setIsModalOpen(true);
  };

  const modalLogin = () => {
    setLoginModalOpen(true);
  };
  const modalLoginClose = () => {
    setLoginModalOpen(false);
  };

  return (
    // <div
    //   className={`${
    //     isAuthenticated ? 'header-main-dark-auth' : 'header-main-dark-unauth'
    //   }`}
    <div className={`header-main-${theme}`}>
      <nav>
        <div className="header-root">
          <Link to={"/"}>
            {theme === "dark" ? (
              <img
                src={width < 480 ? MobileLogo : DesktopLogo}
                alt="AB1 Logo"
                className="brand-logo"
                onClick={() => history.push("/")}
              />
            ) : (
              <img
                src={width < 480 ? MobileLogoDark : DesktopLogoDark}
                alt="AB1 Logo"
                className="brand-logo"
                onClick={() => history.push("/")}
              />
            )}
          </Link>
          <div className="header-sections nav-grp">
            {navLinks.map(({ name, route }, index) => {
              return (
                <HashLink
                  className={`ab1-nav-links ${
                    theme === "dark" ? "theme-light" : "theme-dark"
                  }`}
                  key={index}
                  to={route}
                >
                  {name}
                </HashLink>
              );
            })}
          </div>
          <div className="header-sections header-right">
            {isAuthenticated ? (
              <>
                {theme === "dark" && (
                  <>
                    <div
                      className={`ab1-nav-links ${
                        theme === "dark" ? "theme-light" : "theme-dark"
                      }`}
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={
                        theme === "dark"
                          ? { color: "white" }
                          : { color: "black" }
                      }
                    >
                      my account
                    </div>
                    <div
                      className="dropdown-menu"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => history.push("/my-account")}
                      >
                        ACCOUNT
                      </a>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => history.push("/my-trips")}
                      >
                        MY TRIPS
                      </a>
                      <a
                        className="dropdown-item"
                        href="/"
                        onClick={() => {
                          console.log("logout");
                          delete_cookie("SearchFilterData");
                          //localStorage.setItem("socialLogin", "no")
                          localStorage.removeItem("socialLogin");
                          Auth.signOut({});

                          //   Auth.signOut({})
                          //    .then((a) => (window.location.href = "/"))
                          // //   .then(() => {
                          // //    // openModal();
                          // // })
                          //   .catch(console.error);
                        }}
                      >
                        LOG OUT
                      </a>
                      <a
                        className="dropdown-item"
                        href="#"
                        onClick={() => {
                          setAccountDeleteModal(true);
                        }}
                      >
                        DELETE
                      </a>
                    </div>
                  </>
                )}
              </>
            ) : (
              <div className="right-menu">
                {theme === "dark" && (
                  <div
                    className={`ab1-nav-links ${
                      theme === "dark" ? "theme-light" : "theme-dark"
                    }`}
                    onClick={() => modalLogin(true)}
                    style={
                      theme === "dark" ? { color: "white" } : { color: "black" }
                    }
                  >
                    Login
                  </div>
                )}
                {/* <Link
                  className={`ab1-nav-links ${
                    theme === "dark" ? "theme-light" : "theme-dark"
                  }`}
                  onClick={openModal}
                  to="#"
                >
                  login
                </Link> */}
                {/* <Link
                  className={`ab1-nav-links ${theme === 'dark' ? 'theme-light' : 'theme-dark'
                    }`}
                  to="/create-account"
                >
                  sign up
                </Link> */}
              </div>
            )}
          </div>
          <div className="mobile-header-sections header-right-mobile">
            <img
              onClick={() => history.push("/concierge")}
              src={theme === "dark" ? QuestionMark : QuestionMarkL}
              alt="Help"
              className="header-menu"
            />
            <div>
              <img
                src={theme === "dark" ? OpenMenu : OpenMenuL}
                onClick={handleOpenMenu}
                alt="menuitems"
                className="header-menu"
              />
              <span
                onClick={handleCloseMenu}
                className="header-menu"
                style={
                  theme === "dark"
                    ? { fontSize: "25px", color: "white", display: "none" }
                    : { fontSize: "25px", color: "black", display: "none" }
                }
              >
                <AiOutlineClose />
              </span>
            </div>
          </div>
        </div>
        <div
          id="mobile-menulist"
          style={
            theme === "dark"
              ? { backgroundColor: "#000" }
              : { backgroundColor: "white" }
          }
        >
          <div style={{ padding: "20px 0" }}>
            {navMobileLinks.map(({ name, route }, index) => {
              return (
                <HashLink
                  className={`ab1-nav-links grp-list ${
                    theme === "dark" ? "theme-light" : "theme-dark"
                  }`}
                  onClick={handleCloseMenu}
                  key={index}
                  to={route}
                >
                  {name}
                </HashLink>
              );
            })}
          </div>
          {/* <Link
            className={`ab1-nav-links unq-list ${
              theme === 'dark' ? 'theme-light' : 'theme-dark'
            }`}
            onClick={handleCloseMenu}
            to='/concierge'
          >
            concierge
          </Link> */}
          {isAuthenticated ? (
            <>
              {theme === "dark" && (
                <div style={{ padding: "20px 0" }}>
                  <Link
                    className={`ab1-nav-links grp-list ${
                      theme === "dark" ? "theme-light" : "theme-dark"
                    }`}
                    onClick={handleCloseMenu}
                    to="/my-account"
                  >
                    my account
                  </Link>
                  <Link
                    className={`ab1-nav-links grp-list ${
                      theme === "dark" ? "theme-light" : "theme-dark"
                    }`}
                    onClick={() => {
                      console.log("logout");
                      delete_cookie("SearchFilterData");
                      //localStorage.setItem("socialLogin", "no")
                      localStorage.removeItem("socialLogin");
                      Auth.signOut({})
                        // .then((a) => (window.location.href = "/login"))
                        .then({ openModal })
                        .catch(console.error);
                    }}
                    to="#"
                  >
                    logout
                  </Link>
                </div>
              )}
            </>
          ) : (
            <>
              {theme === "dark" && (
                <Link
                  className={`ab1-nav-links unq-list ${
                    theme === "dark" ? "theme-light" : "theme-dark"
                  }`}
                  onClick={openModal}
                  to="#"
                  style={
                    theme === "dark" ? { color: "white" } : { color: "black" }
                  }
                >
                  login
                </Link>
              )}
            </>
          )}
        </div>
      </nav>
      <div>
        {accountDeleteModal && (
          <AccountDeleteModal
            status={accountDeleteModal}
            onChange={setAccountDeleteModal}
          />
        )}
      </div>
      <Modal
        createLogin={true}
        close={() => setIsModalOpen(false)}
        show={isModalOpen}
        preventClose={true}
      >
        <Login />
      </Modal>

      {loginModalOpen === true && (
        <GeneralModal modaltype="login" modalLoginClose={modalLoginClose} />
      )}
    </div>
  );
};

function mapStateToProps({ auth }) {
  return {
    loginStatus: auth.loginStatus,
    loginUserData: auth.userData,
    createAccount: auth.createAccount,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    updateLoginStatus: (status, userData, createAccount) =>
      dispatch({
        type: UPDATE_AUTH_DATA,
        loginStatus: status,
        userData: userData,
        createAccount: createAccount,
      }),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);
